
export const initHeader = () => {
    document.addEventListener("DOMContentLoaded", () => {
        alert("asd");
        const mobileMenuBtn = document.querySelector(".header-mobile-menu");
        if(mobileMenuBtn) {
            mobileMenuBtn.addEventListener("click", () => {
                const documentHtml = document.querySelector("html");
                const documentBody = document.querySelector("body");
                documentHtml.classList.toggle("overflow-hidden");
                documentBody.classList.toggle("overflow-hidden");
            });
        }
    });
}; 